import React from "react";

export const CartProductQuantity = ({ item, settings }) => {
  const { routes, block_settings } = settings;
  const blockSettings = block_settings || {};

  // Extract styling settings
  const {
    text_color = '#000000',
    secondary_text_color = '#666666',
    border_color = '#e0e0e0',
    quantity_border_radius = 4,
    quantity_text_size = 14
  } = blockSettings;

  const LayoutComponent: any = 'ajax-cart-quantity';

  // Styles for the quantity container
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',

    justifySelf: 'start',
    border: `1px solid ${border_color}`,
    borderRadius: `${quantity_border_radius * 6}px`, // Make it more rounded like the design
    backgroundColor: '#ffffff',
    padding: '4px',
    gap: '0px'
  };

  // Styles for the buttons
  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: secondary_text_color,
    fontSize: '12px',
    textDecoration: 'none',
    borderRadius: `${quantity_border_radius * 4}px`,
    transition: 'background-color 0.2s ease'
  };

  // Styles for the input
  const inputStyle = {
    width: '40px',
    height: '32px',
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'center' as const,
    fontSize: `${quantity_text_size}px`,
    color: text_color,
    fontWeight: '500',
    outline: 'none'
  };

  return (
    <div className="cart-product-quantity">
      <LayoutComponent style={containerStyle}>
        <a
          href={`${routes?.cart_change_url || '/cart/change'}?id=${item.key}&quantity=${item.quantity - 1}`}
          style={buttonStyle}
          data-ajax-cart-quantity-minus
          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          <i className="icon icon-quantity-minus font-bold" style={{ fontSize: '10px' }} />
        </a>
        <input
          type="number"
          value={item.quantity}
          name="updates[]"
          className="font-bold"
          data-ajax-cart-quantity-input={item.key}
          style={inputStyle}
          readOnly={true}
          min="0"
        />
        <a
          href={`${routes?.cart_change_url || '/cart/change'}?id=${item.key}&quantity=${item.quantity + 1}`}
          style={buttonStyle}
          data-ajax-cart-quantity-plus
          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          <i className="icon icon-quantity-plus font-bold" style={{ fontSize: '10px' }} />
        </a>
      </LayoutComponent>
    </div>
  );
};
